import { Typography, message, Input, Row, Col, Card } from "antd";
import { useState, useEffect } from "react";
import PersonasPVIndex from "./PersonasPVIndex"; // Adjust the import path as needed
import axios from "axios";
import { useAuth } from "../../layout/auth";
import PageTitle from "../../utils/PageTitle";
import PageWrapper from "../../utils/PageWrapper";
import { Building2 } from "lucide-react";

export default function VerifiedPlaces() {
  const [personas, setPersonas] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredPersonas, setFilteredPersonas] = useState([]);
  const [loading, setLoading] = useState(false);

  const auth = useAuth(); // Assuming you still want to use auth for fetching data

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/personas/pv`) // Adjust the endpoint as needed
      .then((res) => {
        setPersonas(res.data);
        setFilteredPersonas(res.data); // Initialize filtered personas
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (search) {
      const filtered = personas.filter((persona) => {
        return (
          persona?.NombreCompleto?.toLowerCase().includes(search.toLowerCase()) ||
          persona?.TipoPersona?.toLowerCase().includes(search.toLowerCase()) ||
          persona?.Nacionalidad?.toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredPersonas(filtered);
    } else {
      setFilteredPersonas(personas);
    }
  }, [search, personas]);

  return (
    <PageWrapper className="verified-places-main-card">
      <PageTitle icon={<Building2 />} title="Razones Sociales" />
      <div
        style={{
          padding: "16px",
          background: "rgba(249, 250, 251, 0.8)",
          borderRadius: "12px",
          border: "1px solid rgba(229, 231, 235, 0.6)",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05)",
          marginBottom: "24px",
        }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Input.Search
              placeholder="Buscar razón social"
              onSearch={(value) => {
                setSearch(value);
              }}
              enterButton="Buscar"
              size="large"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "right" }}>
            {/* No action buttons for now */}
          </Col>
        </Row>
      </div>
      <PersonasPVIndex personas={filteredPersonas} loading={loading} />
    </PageWrapper>
  );
}
